//
//
//
//
//
//
//
//
import List from './List';
export default {
  components: {
    List: List
  },
  data: function data() {
    return {
      isShowList: true
    };
  }
};